import { LocationDetailsResponse } from 'src/app/shared/models/LocationDetailsResponse.model';

export class OnboardingRequest {
  public organizationName: string;
  public logoFileId: number;
  public address: LocationDetailsResponse;
}
